import {
  Component,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
  forwardRef,
  ViewChild,
  ElementRef
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn, ValidationErrors, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableColumn, TableRowSelectorDirective, LegacyTableModule } from 'remarketing-ui-components-lib';
import { Select, Store } from '@ngxs/store';
import {
  Configuration,
  ConfigurationState,
  LaunchDarklyService,
  Organization,
  OrganizationService,
  SaveOrganization,
  UserService
} from 'remarketing-angular-library';
import { AnalyticsService, SaComponent } from 'smartauction-frontend-micro-library';
import { EMPTY, Observable, Subject } from 'rxjs';
import { catchError, filter, map, take, takeUntil } from 'rxjs/operators';
import { tenantClass } from '../../util/state-selectors';
import MicroModal from 'micromodal';
import { CheckUnsavedForms } from '../../interfaces/check-unsaved-forms';
import { Router } from '@angular/router';
import { AddressChangedModalComponent } from '../address-changed-modal/address-changed-modal.component';
import { TranslocoService } from '@jsverse/transloco';
import { AddressChangeModalComponent } from '../address-change-modal/address-change-modal.component';
import { AddressChangeDrawerComponent } from '../address-change-drawer/address-change-drawer.component';
import { SaveChangesModalComponent } from '../save-changes-modal/save-changes-modal.component';
import { NgxMaskModule } from 'ngx-mask';
import { SuccessMessageComponent } from '../success-message/success-message.component';
import { ErrorMessageComponent } from '../error-message/error-message.component';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { AlternateContact } from 'src/app/enums/alternateContact.enum';

@Component({
    selector: 'app-dealer-contact',
    templateUrl: './dealer-contact.component.html',
    styleUrls: ['./dealer-contact.component.scss'],
    providers: [{ provide: CheckUnsavedForms, useExisting: forwardRef(() => DealerContactComponent) }],
    imports: [ErrorMessageComponent, SuccessMessageComponent, NgClass, NgTemplateOutlet, FormsModule, ReactiveFormsModule, NgxMaskModule, LegacyTableModule, SaveChangesModalComponent, AddressChangeDrawerComponent, AddressChangeModalComponent, AddressChangedModalComponent, AsyncPipe]
})
export class DealerContactComponent extends SaComponent implements OnInit, CheckUnsavedForms {
  @Output() disableParentAccordion = new EventEmitter<boolean>();
  @Output() closeParentAccordion = new EventEmitter();
  @ViewChild(AddressChangedModalComponent) addressChangedModalComponent: AddressChangedModalComponent;
  @Select(ConfigurationState.configuration) private configuration$: Observable<Configuration>;
  @Select(tenantClass) tenantClass$: Observable<string>;
  tenantName$: Observable<string>;
  tenantName: string;
  private cancelEditing$: Subject<boolean> = new Subject();

  modalId = 'dealer-contact__save-changes-modal';

  organization: Organization;

  // flag to detect if currently editing phoneNumberForm
  phoneEditMode = false;
  phoneNumberForm: UntypedFormGroup;
  phoneNumberFormSubmitted = false;

  buyerContactForm: UntypedFormGroup;
  @ViewChild('buyerDrawer') buyerDrawer: TableRowSelectorDirective;
  sellerContactForm: UntypedFormGroup;
  @ViewChild('sellerDrawer') sellerDrawer: TableRowSelectorDirective;
  pickupContactForm: UntypedFormGroup;
  @ViewChild('pickupDrawer') pickupDrawer: TableRowSelectorDirective;
  titleContactForm: UntypedFormGroup;
  @ViewChild('titleDrawer') titleDrawer: TableRowSelectorDirective;
  arbitrationContactForm: UntypedFormGroup;
  @ViewChild('arbitrationDrawer') arbitrationDrawer: TableRowSelectorDirective;
  sellerEditMode = false;
  buyerEditMode = false;
  pickupEditMode = false;
  titleEditMode = false;
  arbitrationEditMode = false;
  forms: any;
  requestPhysicalAddress = false;
  requestTitleAddress = false;
  isMobile = false;
  showError = false;
  showSuccess = false;
  message: string;
  showContactDetailsError = false;
  showContactDetailsSuccess = false;
  contactDetailsSuccessMessage: string;
  userRoles: string[];
  showBuyerContacts = true;
  showSellerContacts = true;
  showSameAsSellerCheckbox = false;
  sameAsSellerFieldStyle = {
    buyer: false,
    pickup: false,
    title: false,
    arbitration: false
  };

  @ViewChild('contactPrimaryPhone') contactPrimaryPhone;
  @ViewChild('primaryPhoneText') primaryPhoneText;
  @ViewChild('editContactNumbers') editContactNumbers;
  @ViewChild('editBuyer') editBuyer;
  @ViewChild('editSeller') editSeller;
  @ViewChild('editPickup') editPickup;
  @ViewChild('editTitle') editTitle;
  @ViewChild('editArbitration') editArbitration;

  dealerContactTranslations = {
    titleContact: '',
    editTitleContact: '',
    editTitleContactMessage: '',
    arbitrationContact: '',
    editArbitrationContact: '',
    editArbitrationContactMessage: '',
    edit: '',
    name: '',
    enterName: '',
    email: '',
    enterEmail: '',
    phone: '',
    enterPhoneToContinue: '',
    btnSave: '',
    btnCancel: '',
    btnClose: '',
    physicalAddress: '',
    ariaLabelRequestPhysical: '',
    requestChange: '',
    titleAddress: '',
    ariaLabelRequestTitle: '',
    pageHeader: '',
    phoneNumbers: '',
    primaryPhone: '',
    textAltPhone: '',
    ariaLabelEditContact: '',
    labelPrimaryPhone: '',
    alternatePhone: '',
    enterPhoneNumber: '',
    labelContacts: '',
    contactInfo: '',
    captionDealerShip: '',
    textBuyerContact: '',
    editBuyerContact: '',
    editBuyerContactInfo: '',
    sellerContact: '',
    editSellerContact: '',
    sellerContactInfo: '',
    pickupContact: '',
    editPickupContact: '',
    editPickupContactMessage: '',
    contactDetailsSuccessfullyUpdate: '',
    alternateBuyerContact: '',
    alternatePickupContact: '',
    alternateSellerContact: '',
    alternateArbitrationContact: '',
    alternateContactGeneralError: '',
    frenchPreferred: '',
    labelSameAsSellerCheckbox: '',
    samePrimarySecondaryNameError: ''
  };

  columns: TableColumn[] = [
    { key: 'role', label: '' },
    { key: 'name', label: '' },
    { key: 'email', label: '' },
    { key: 'phone', label: '' },
    { key: 'options', label: '' }
  ];

  data = {
    buyer: { name: '', email: '', phone: '', language: false, alternateBuyer: {name: '', email: '', phone: '', language: false } },
    seller: { name: '', email: '', phone: '', language: false, alternateSeller: {name: '', email: '', phone: '', language: false } },
    pickup: { name: '', email: '', phone: '', language: false, alternatePickup: {name: '', email: '', phone: '', language: false } },
    title: { name: '', email: '', phone: '', language: false },
    arbitration: { name: '', email: '', phone: '', language: false,
      ...(this.isArbitrationSecondaryContactInfoEnabled && {
        alternateArbitration: {name: '', email: '', phone: '', language: false }
      })
    },
  };

  cardConfig = {
    options: {
      fullWidth: true,
      showLabel: false
    }
  };

  primaryPhone = '';
  altPhone = '';
  variant = '';

  @ViewChild('pageHeading') pageHeading: ElementRef;
  routerState: any;

  get isDrawerOpen(): boolean {
    return (this.requestPhysicalAddress || this.requestTitleAddress) && !this.phoneEditMode;
  }

  get numberFormValidator() {
    return this.phoneNumberForm.controls;
  }

  get isAddressChangeDisabled(): boolean {
    return !this.launchDarklyService.getFeatureFlag('profile-addressChangeRequestButtonEnabled', false);
  }

  get alternateSeller(): any {
    return this.sellerContactForm.get('alternateSeller');
  }

  get alternateBuyer(): any {
    return this.buyerContactForm.get('alternateBuyer');
  }

  get alternatePickup(): any {
    return this.pickupContactForm.get('alternatePickup');
  }

  get alternateArbitration(): any {
    return this.arbitrationContactForm.get('alternateArbitration');
  }

  get isAlternateSellerPhoneValid(): boolean {
    return !this.alternateSeller?.errors?.phone && this.alternateSeller?.controls.phone.status === 'VALID';
  }

  get isAlternateSellerEmailValid(): boolean {
    return !this.alternateSeller?.errors?.email && this.alternateSeller?.controls.email.status === 'VALID';
  }

  get isAlternateSellerNameValid(): boolean {
    return !this.alternateSeller?.errors?.name && this.alternateSeller?.controls.name.status === 'VALID';
  }

  get isAlternateSellerValid(): boolean {
    return this.alternateSeller.status === 'VALID';
  }

  get isAlternateBuyerPhoneValid(): boolean {
    return !this.alternateBuyer?.errors?.phone && this.alternateBuyer?.controls.phone.status === 'VALID';
  }

  get isAlternateBuyerNameValid(): boolean {
    return !this.alternateBuyer?.errors?.name && this.alternateBuyer?.controls.name.status === 'VALID';
  }

  get isAlternateBuyerEmailValid(): boolean {
    return !this.alternateBuyer?.errors?.email && this.alternateBuyer?.controls.email.status === 'VALID';
  }

  get isAlternateBuyerValid(): boolean {
    return this.alternateBuyer.status === 'VALID';
  }

  get isAlternatePickupPhoneValid(): boolean {
    return !this.alternatePickup?.errors?.phone && this.alternatePickup?.controls.phone.status === 'VALID';
  }

  get isAlternatePickupNameValid(): boolean {
    return !this.alternatePickup?.errors?.name && this.alternatePickup?.controls.name.status === 'VALID';
  }

  get isAlternatePickupEmailValid(): boolean {
    return !this.alternatePickup?.errors?.email && this.alternatePickup?.controls.email.status === 'VALID';
  }

  get isAlternatePickupValid(): boolean {
    return this.alternatePickup.status === 'VALID';
  }

  get isAlternateArbitrationPhoneValid(): boolean {
    return !this.alternateArbitration?.errors?.phone && this.alternateArbitration?.controls.phone.status === 'VALID';
  }

  get isAlternateArbitrationNameValid(): boolean {
    return !this.alternateArbitration?.errors?.name && this.alternateArbitration?.controls.name.status === 'VALID';
  }

  get isAlternateArbitrationEmailValid(): boolean {
    return !this.alternateArbitration?.errors?.email && this.alternateArbitration?.controls.email.status === 'VALID';
  }

  get isAlternateArbitrationValid(): boolean {
    return this.alternateArbitration.status === 'VALID';
  }

  get isArbitrationPrimaryAndSecondaryNameSame(): boolean {
    return this.arbitrationContactForm?.controls.name.value.toLowerCase() === this.alternateArbitration?.controls.name.value.toLowerCase() &&
    this.arbitrationContactForm?.controls.name.value !== '' && this.alternateArbitration?.controls.name.value !== '';
  }

  shouldShowAlternateArbitrationError(): boolean {
    return this.isArbitrationSecondaryContactInfoEnabled && (!this.isAlternateArbitrationValid || this.isArbitrationPrimaryAndSecondaryNameSame);
  }

  get isArbitrationSecondaryContactInfoEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('arbitration-secondaryContactInfoEnabled', false);
  }

  get isCanadianTenantEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('canadianTenantEnabled', false);
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store: Store,
    private organizationService: OrganizationService,
    private analyticsService: AnalyticsService,
    private readonly router: Router,
    private readonly translocoService: TranslocoService,
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly userService: UserService
  ) {
    super();
    const currentNaviation = this.router.currentNavigation();

    if (currentNaviation && currentNaviation.extras && currentNaviation.extras.state) {
      this.routerState = currentNaviation.extras.state;
    }
  }

  ngOnInit() {
    this.getTranslations();

    this.store
      .select(_state => _state.org.organization)
      .pipe(
        takeUntil(this.destroyed$),
        filter(organization => !!organization)
      )
      .subscribe(organization => {
        this.organization = organization;
        this.primaryPhone =
          organization && organization.primaryPhone ? this.reformatPhone(organization.primaryPhone) : '';
        this.altPhone =
          organization && organization.alternatePhone ? this.reformatPhone(organization.alternatePhone) : '';

        this.data = {
          arbitration: {
            ...organization.contactDetails.arbitration,
            language: organization.contactDetails.arbitration?.language === 'FR',
            phone: organization.contactDetails.arbitration?.phone ?
              this.reformatPhoneWithoutCountryCode(organization.contactDetails.arbitration?.phone) : '',
            ...(this.isArbitrationSecondaryContactInfoEnabled && {
              alternateArbitration: {
                ...organization.contactDetails.alternateArbitration,
                language: organization.contactDetails.alternateArbitration?.language === 'FR',
                phone: organization.contactDetails.alternateArbitration?.phone ?
                  this.reformatPhoneWithoutCountryCode(organization.contactDetails.alternateArbitration?.phone) : ''
              }
            })
          },
          buyer: {
            ...organization.contactDetails.buyer,
            language: organization.contactDetails.buyer?.language === 'FR',
            alternateBuyer: {
              ...organization.contactDetails.alternateBuyer,
              language: organization.contactDetails.alternateBuyer?.language === 'FR',
              phone: organization.contactDetails.alternateBuyer?.phone ?
                this.reformatPhoneWithoutCountryCode(organization.contactDetails.alternateBuyer?.phone) : ''
            }
          },
          seller: {
            ...organization.contactDetails.seller,
            language: organization.contactDetails.seller?.language === 'FR',
            alternateSeller: {
              ...organization.contactDetails.alternateSeller,
              language: organization.contactDetails.alternateSeller?.language === 'FR',
              phone: organization.contactDetails.alternateSeller?.phone ?
                this.reformatPhoneWithoutCountryCode(organization.contactDetails.alternateSeller?.phone) : ''
            }
          },
          title: {
            ...organization.contactDetails.title,
            language: organization.contactDetails.title?.language === 'FR',
            phone: organization.contactDetails.title?.phone ?
              this.reformatPhoneWithoutCountryCode(organization.contactDetails.title?.phone) : ''
          },
          pickup: {
            ...organization.contactDetails.pickup,
            language: organization.contactDetails.pickup?.language === 'FR',
            alternatePickup: {
              ...organization.contactDetails.alternatePickup,
              language: organization.contactDetails.alternatePickup?.language === 'FR',
              phone: organization.contactDetails.alternatePickup?.phone ?
                this.reformatPhoneWithoutCountryCode(organization.contactDetails.alternatePickup?.phone) : ''
            }
          }
        };
      });

    this.tenantName$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantName));
    this.tenantName$.pipe(takeUntil(this.destroyed$)).subscribe(tenantName => (this.tenantName = tenantName));

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const controlConfig = {
      name: ['', [Validators.required, Validators.maxLength(100)]],
      email: ['', [Validators.pattern(emailRegex), Validators.required]],
      phone: ['', [Validators.minLength(10), Validators.maxLength(12), Validators.required]],
      language: [false]
    };

    this.titleContactForm = this.formBuilder.group(controlConfig, {});
    this.arbitrationContactForm = this.formBuilder.group(controlConfig, {});
    const alternateControlConfig = {
      name: ['', [Validators.maxLength(100)]],
      email: ['', [Validators.pattern(emailRegex)]],
      phone: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      language: [false]
    };

    this.buyerContactForm = this.formBuilder.group({
      alternateBuyer: this.formBuilder.group(alternateControlConfig, { validators: this.alternateContactValidator(), updateOn: 'submit' }),
      ...controlConfig
    });
    this.sellerContactForm = this.formBuilder.group({
      alternateSeller: this.formBuilder.group(alternateControlConfig, { validators: this.alternateContactValidator(), updateOn: 'submit' }),
      ...controlConfig
    });
    this.pickupContactForm = this.formBuilder.group({
      alternatePickup: this.formBuilder.group(alternateControlConfig, { validators: this.alternateContactValidator(), updateOn: 'submit' }),
      ...controlConfig
    });

    this.arbitrationContactForm = this.formBuilder.group({
      ...(this.isArbitrationSecondaryContactInfoEnabled && {
        alternateArbitration: this.formBuilder.group(alternateControlConfig, {
          validators: this.alternateContactValidator(),
          updateOn: 'submit'
        })
      }),
      ...controlConfig
    }, {
      validators: this.validatePrimaryAndSecondaryName(AlternateContact.arbitration), updateOn: 'submit'
    }
  );

    this.phoneNumberForm = this.formBuilder.group({
      primaryNumber: [this.primaryPhone.replace(/-/g, ''), [Validators.minLength(10), Validators.maxLength(10)]],
      altNumber: [this.altPhone.replace(/-/g, ''), [Validators.minLength(10), Validators.maxLength(10)]]
    });

    this.organization = this.store.selectSnapshot(_state => _state.org.organization);
    this.userRoles = this.store.selectSnapshot(_state => _state.user.userProfile.fineGrainedRoles);

    this.showContactsPerRole();

    this.analyticsService.trackPageLoad({
      page: {
        pageName: `${this.analyticsService.digitalData.page.category.site}:Profile Settings:Dealership:Contact`,
        section: 'Profile Settings',
        subsection: 'Dealership',
        title: 'Contact'
      }
    });

    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
    this.setShowSameAsSellerCheckbox();
  }

  validatePrimaryAndSecondaryName(alternateContact: AlternateContact): ValidatorFn{
    return(control: AbstractControl): ValidationErrors | null => {
       const primaryName = control.get('name')?.value;
       const alternateName = control.get(alternateContact)?.get('name')?.value;
      if(primaryName && alternateName && primaryName.toLowerCase() === alternateName.toLowerCase()){
        return {
          samePrimaryAndSecondaryName: { message: 'Secondary contact name cannot match primary contact name.'}
        }
      }
      return null;
    }
  }

  ngAfterViewInit(): void {
    if (this.routerState && this.routerState.focus) {
      this.pageHeading.nativeElement.focus();
    }
  }

  setShowSameAsSellerCheckbox() {
    this.showSameAsSellerCheckbox = !(this.userService.isBuyerOnlyRole());
  }

  alternateContactValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors = {
        email: control.value.email.length <= 0,
        name: control.value.name.length <= 0,
        phone: control.value.phone.length <= 0
      };
      const isValid = errors.email && errors.name && errors.phone || !errors.email && !errors.name && !errors.phone;
      return isValid ? null : { ...errors };
    };
  }

  onPhoneEditMode() {
    this.phoneEditMode = true;
    this.drawerClosed();
    setTimeout(() => {
      const phoneInput = this.contactPrimaryPhone;
      if (phoneInput) {
        phoneInput.nativeElement.focus();
      }
    }, 0);
  }

  changePhoneNumbers() {
    this.showSuccess = false;
    this.showError = false;
    if (this.phoneNumberForm.invalid) {
      return;
    }

    const newPrimaryNumber = this.phoneNumberForm.get('primaryNumber').value;
    const newAltNumber = this.phoneNumberForm.get('altNumber').value;

    const payload = {
      ...this.organization,
      primaryPhone: newPrimaryNumber,
      alternatePhone: newAltNumber
    };

    this.organizationService.updateOrganization(this.organization.oeUuid, payload).pipe(take(1)).subscribe({
      next : (response: any) => {
        this.store.dispatch(new SaveOrganization(response));
        this.setMessage();

        this.phoneEditMode = false;
        this.phoneNumberFormSubmitted = true;
        this.showSuccess = true;

        setTimeout(() => {
          const phoneInput = this.primaryPhoneText;
          if (phoneInput) {
            phoneInput.nativeElement.focus();
          }
        }, 0);
      },
      error : () => {
        this.showError = true;
      }
    });
  }

  reformatPhone(phone) {
    phone = phone.replace(/-/g, '');
    if (phone.length > 0) {
      if (phone.length === 11) {
        phone = phone.slice(1, 4) + '-' + phone.slice(4, 7) + '-' + phone.slice(7);
        return phone;
      } else {
        phone = phone.slice(0, 3) + '-' + phone.slice(3, 6) + '-' + phone.slice(6);
        return phone;
      }
    }
  }

  reformatPhoneWithoutCountryCode(phone) {
    phone = phone.replace(/-/g, '');
    return phone.length > 0 && phone.length === 11 ? phone.slice(1) : phone;
  }

  f(role) {
    const form = this.form(role);
    return form.controls;
  }

  updateForm(role, contact) {
    this.buyerEditMode = role === 'buyer';
    this.sellerEditMode = role === 'seller';
    this.pickupEditMode = role === 'pickup';
    this.titleEditMode = role === 'title';
    this.arbitrationEditMode = role === 'arbitration';

    if (contact.phone == null) {
      contact.phone = ' ';
    }
    const temp = { ...contact };
    const form = this.form(role);
    delete temp.role;
    temp.phone = this.reformatPhone(temp.phone);
    temp.phone = temp.phone.replace(/-/g, '');
    form.patchValue(temp);

    this.focusElement(role + '_header');
  }

  capitalize(roleName){
    return roleName[0].toUpperCase() + roleName.slice(1);
  }

  checkLanguage(checked): string {
    return checked ? 'FR' : 'EN';
  }

  createPayload() {
    return {
      arbitration: {
        ...this.data.arbitration,
        language: this.checkLanguage(this.data.arbitration.language),
        ...(this.isArbitrationSecondaryContactInfoEnabled && {
          alternateArbitration: {
            ...this.data.arbitration.alternateArbitration,
            language: this.checkLanguage(this.data.arbitration.alternateArbitration.language)
          }
        })
      },
      buyer: {
        ...this.data.buyer,
        language: this.checkLanguage(this.data.buyer.language),
        alternateBuyer: {
          ...this.data.buyer.alternateBuyer,
          language: this.checkLanguage(this.data.buyer.alternateBuyer.language)
        }
      },
      seller: {
        ...this.data.seller,
        language: this.checkLanguage(this.data.seller.language),
        alternateSeller: {
          ...this.data.seller.alternateSeller,
          language: this.checkLanguage(this.data.seller.alternateSeller.language)
        }
      },
      title: {
        ...this.data.title,
        language: this.checkLanguage(this.data.title.language)
      },
      pickup: {
        ...this.data.pickup,
        language: this.checkLanguage(this.data.pickup.language),
        alternatePickup: {
          ...this.data.pickup.alternatePickup,
          language: this.checkLanguage(this.data.pickup.alternatePickup.language)
        }
      }
    };
  }

  shouldIncludeAlternate(alternate) {
    if (alternate === 'arbitrationAlternate') {
      return this.isArbitrationSecondaryContactInfoEnabled;
    }
    return true;
  }

  onSubmit(e, role, contact) {
    e.preventDefault();
    this.showContactDetailsSuccess = false;
    this.showContactDetailsError = false;
    const form = this.form(role);
    const primaryChecked = e.target[`${role}_language`]?.checked;
    const secondaryChecked = e.target[`${role}_alternate_language`]?.checked;

    if (form.invalid) {
      return;
    }
    const dataObj = {...this.createPayload()};
    const alternate = 'alternate' + this.capitalize(role);
    const altform = form.get(alternate)?.value;
    const payload = {
      ...this.organization,
      contactDetails: {
        ...dataObj,
        [role]: {
          name: form.controls.name.value,
          email: form.controls.email.value,
          phone: form.controls.phone.value,
          language: this.checkLanguage(primaryChecked)
        },
        ...(this.shouldIncludeAlternate(alternate) && {
          [alternate]: {
            name: altform?.name,
            email: altform?.email,
            phone: altform?.phone,
            language: this.checkLanguage(secondaryChecked)
          }
        })
      }
    };

    this.organizationService.updateOrganization(this.organization.oeUuid, payload).pipe(take(1)).subscribe({
      next: (response : any) => {
        this.store.dispatch(new SaveOrganization(response));
          contact.name = form.controls.name.value;
          contact.email = form.controls.email.value;
          contact.phone = this.reformatPhone(form.controls.phone.value);
          contact.language = primaryChecked;
          contact[alternate] = form.get(alternate)?.value;
          this.showContactDetailsSuccess = true;

          if (role === 'buyer') {
            this.buyerEditMode = false;
            this.sameAsSellerFieldStyle.buyer = false;
            this.buyerDrawer.close();
          }
          if (role === 'seller') {
            this.sellerEditMode = false;
            this.sellerDrawer.close();
          }
          if (role === 'pickup') {
            this.pickupEditMode = false;
            this.sameAsSellerFieldStyle.pickup= false;
            this.pickupDrawer.close();
          }
          if (role === 'title') {
            this.titleEditMode = false;
            this.sameAsSellerFieldStyle.title = false;
            this.titleDrawer.close();

            if (this.launchDarklyService.getFeatureFlag('purchase-titleContactRequiredEnabled', false)) {
              this.organizationService.getDealerContactFields().pipe(
                take(1),
                catchError(() => EMPTY)
              ).subscribe(contactFields => {
                this.store.dispatch(new SaveOrganization({ ...response, isTitleContactPresent: contactFields.isTitleContactPresent }));
              });
            }
          }
          if (role === 'arbitration') {
            this.arbitrationEditMode = false;
            this.sameAsSellerFieldStyle.arbitration = false;
            this.arbitrationDrawer.close();
          }
      },
      error : () => {
        this.showContactDetailsError = true;
      }
    });
  }

  /* istanbul ignore next */
  closeDrawer(e) {
    const elem = e.target as HTMLElement;

    if (elem) {
      (elem.parentNode.firstChild as HTMLElement).click();
    }
  }

  form(role) {
    let form = null;
    switch (role) {
    case 'buyer':
      form = this.buyerContactForm;
      break;
    case 'seller':
      form = this.sellerContactForm;
      break;
    case 'pickup':
      form = this.pickupContactForm;
      break;
    case 'title':
      form = this.titleContactForm;
      break;
    case 'arbitration':
      form = this.arbitrationContactForm;
      break;
    }
    form.touched = false;
    return form;
  }

  openMicroModal(modalId: string) {
    MicroModal.show(modalId, {
      disableScroll: true
    });
    const heading = document.querySelector(`#${modalId} h1`) as HTMLElement;
    if (heading) {
      heading.focus();
    }
  }

  openAddressMicroModalOrDrawer(mode: string) {
    this.variant = mode;
    if (this.isMobile) {
      MicroModal.show(`${mode}-address-change-modal`, {
        disableScroll: true
      });
      const heading = document.querySelector(`#${mode}-address-change-modal h1`) as HTMLElement;
      if (heading) {
        heading.focus();
      }
    } else {
      if (mode === 'physical') {
        this.requestPhysicalAddress = true;
        this.requestTitleAddress = false;
        this.phoneEditMode = false;
      } else {
        this.requestPhysicalAddress = false;
        this.requestTitleAddress = true;
        this.phoneEditMode = false;
      }
    }
  }

  detectIfMobile() {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
  }

  // when click GO BACK from the alert Modal
  continueEditing(e) {
    // console.log('back to edit mode');
  }

  // when click DO NOT SAVE CHANGES from the alert modal
  // right now, only implemented for phoneNumberForm
  cancelEditing(e) {
    this.phoneNumberForm.get('primaryNumber').setValue(this.primaryPhone);
    this.phoneNumberForm.get('altNumber').setValue(this.altPhone);

    this.phoneNumberFormSubmitted = false;
    this.phoneEditMode = false;

    this.cancelEditing$.next(true);
    this.cancelEditing$.complete();
    this.closeParentAccordion.emit();
    setTimeout(() => {
      const editContactNumber = this.editContactNumbers;
      if (editContactNumber) {
        editContactNumber.nativeElement.focus();
      }
    }, 0);
  }

  cancelContactForm(e, role) {
    e.preventDefault();

    if (role === 'buyer') {
      if (this.buyerContactForm.touched) {
        this.openMicroModal(role.replace(' ', '') + '__save-changes-modal');
      } else {
        this.cancelContactEditing(role);
        const editBuyer = this.editBuyer;
        if (editBuyer) {
          editBuyer.nativeElement.focus();
        }
      }
    }
    if (role === 'seller') {
      if (this.sellerContactForm.touched) {
        this.openMicroModal(role.replace(' ', '') + '__save-changes-modal');
      } else {
        this.cancelContactEditing(role);
        const editSeller = this.editSeller;
        if (editSeller) {
          editSeller.nativeElement.focus();
        }
      }
    }
    if (role === 'pickup') {
      if (this.pickupContactForm.touched) {
        this.openMicroModal(role.replace(' ', '') + '__save-changes-modal');
      } else {
        this.cancelContactEditing(role);
        const editPickup = this.editPickup;
        if (editPickup) {
          editPickup.nativeElement.focus();
        }
      }
    }
    if (role === 'title') {
      if (this.titleContactForm.touched) {
        this.openMicroModal(role.replace(' ', '') + '__save-changes-modal');
      } else {
        this.cancelContactEditing(role);
        const editTitle = this.editTitle;
        if (this.editTitle) {
          editTitle.nativeElement.focus();
        }
      }
    }
    if (role === 'arbitration') {
      if (this.arbitrationContactForm.touched) {
        this.openMicroModal(role.replace(' ', '') + '__save-changes-modal');
      } else {
        this.cancelContactEditing(role);
        const editArbitration = this.editArbitration;
        if (editArbitration) {
          editArbitration.nativeElement.focus();
        }
      }
    }
  }

  clearValuesOnCancel(role) {
    const form = this.form(role);
    form.controls.name.value = '';
    form.controls.email.value = '';
    form.controls.phone.value = '';
  }

  cancelContactEditing(role) {
    switch (role) {
      case 'buyer': {
        this.clearValuesOnCancel(role);
        this.buyerEditMode = false;
        this.sameAsSellerFieldStyle.buyer = false;
        this.buyerDrawer.close();
        break;
      }
      case 'seller': {
        this.clearValuesOnCancel(role);
        this.sellerEditMode = false;
        this.sellerDrawer.close();
        break;
      }
      case 'pickup': {
        this.clearValuesOnCancel(role);
        this.pickupEditMode = false;
        this.sameAsSellerFieldStyle.pickup = false;
        this.pickupDrawer.close();
        break;
      }
      case 'title': {
        this.clearValuesOnCancel(role);
        this.titleEditMode = false;
        this.sameAsSellerFieldStyle.title = false;
        this.titleDrawer.close();
        break;
      }
      case 'arbitration': {
        this.clearValuesOnCancel(role);
        this.arbitrationEditMode = false;
        this.sameAsSellerFieldStyle.arbitration = false;
        this.arbitrationDrawer.close();
        break;
      }
      case 'Buyer Contact': {
        this.buyerEditMode = false;
        this.sameAsSellerFieldStyle.buyer = false;
        break;
      }
      case 'Seller Contact': {
        this.sellerEditMode = false;
        break;
      }
      case 'Pickup Contact': {
        this.pickupEditMode = false;
        this.sameAsSellerFieldStyle.pickup = false;
        break;
      }
      case 'Title Contact': {
        this.titleEditMode = false;
        this.sameAsSellerFieldStyle.title = false;
        break;
      }
      case 'Arbitration Contact': {
        this.arbitrationEditMode = false;
        this.sameAsSellerFieldStyle.arbitration = false;
        break;
      }
      default: {
        // blank
      }
    }

    this.cancelEditing$.next(true);
    this.cancelEditing$.complete();
    this.closeParentAccordion.emit();
  }

  continueContactEditing() {
    this.cancelEditing$.next(false);
    this.cancelEditing$.complete();
  }

  // three guard function
  // detect URL change, using phoneEditMode flag to see if currently editing the top phoneForm
  // we can use another flag to detect if any table form is being editing
  showNavigationAlert(): Observable<boolean> {
    if (this.phoneEditMode) {
      this.openMicroModal('dealer-contact__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else if (this.buyerEditMode) {
      this.openMicroModal('buyer__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else if (this.sellerEditMode) {
      this.openMicroModal('seller__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else if (this.pickupEditMode) {
      this.openMicroModal('pickup__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else if (this.titleEditMode) {
      this.openMicroModal('title__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else if (this.arbitrationEditMode) {
      this.openMicroModal('arbitration__save-changes-modal');
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    } else {
      this.cancelEditing$ = new Subject<boolean>();
      return this.cancelEditing$.asObservable();
    }
  }

  // check if the form is not save or anything?
  // for Phone Editing Form, just listening on the phoneEditMode flag instead of value change.
  hasUnsavedForms(): boolean {
    if (this.phoneEditMode) {
      return true;
    } else if (this.buyerEditMode && this.buyerContactForm.touched) {
      return true;
    } else if (this.sellerEditMode && this.sellerContactForm.touched) {
      return true;
    } else if (this.pickupEditMode && this.pickupContactForm.touched) {
      return true;
    } else if (this.titleEditMode && this.titleContactForm.touched) {
      return true;
    } else {
      return this.arbitrationEditMode && this.arbitrationContactForm.touched;
    }
  }

  // detecting if tab can be closed if the phoneEditMode is true
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    if (this.hasUnsavedForms()) {
      event.returnValue = this.hasUnsavedForms();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.detectIfMobile();
  }

  showAlert() {
    // do whatever action is expected when you are moving away from unsaved changes
    this.showNavigationAlert();
  }

  focusElement(id) {
    setTimeout(() => {
      const element = document.getElementById(id) as HTMLElement;
      if (element) {
        element.focus();
      }
    }, 0);
  }

  drawerClosed() {
    this.requestPhysicalAddress = false;
    this.requestTitleAddress = false;
  }

  receiveError(data) {
    this.showError = data;
    if (this.isMobile) {
      MicroModal.close(`${this.variant}-address-change-modal`);
    }
    this.drawerClosed();
  }

  addressSaved() {
    this.addressChangedModalComponent.show(this.variant);
    this.drawerClosed();
  }

  setMessage() {
    this.translocoService.selectTranslate('profileManagement.dealercontact.textSuccessfullyupdate').pipe(take(1)).subscribe(translate => {
      this.message = translate;
    });
  }

  getTranslations() {
    const keyParams = {
      'profileManagement.dealercontact': {},
      'common': {}
    };

    this.translocoService.selectTranslateObject(keyParams).pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.columns[0].label = translate[0].tableHeader.labelRole;
      this.columns[1].label = translate[0].tableHeader.labelName;
      this.columns[2].label = translate[0].tableHeader.labelEmail;
      this.columns[3].label = translate[0].tableHeader.labelPhone;
      this.columns[4].label = translate[0].tableHeader.labelOption;

      this.dealerContactTranslations.btnSave = translate[1].btnSave;
      this.dealerContactTranslations.btnCancel = translate[1].btnCancel;
      this.dealerContactTranslations.btnClose = translate[1].btnClose;
      this.dealerContactTranslations.alternateContactGeneralError = translate[0].alternateContactGeneralError;
      this.dealerContactTranslations.arbitrationContact = translate[0].arbitrationContact;
      this.dealerContactTranslations.editArbitrationContact = translate[0].editArbitrationContact;
      this.dealerContactTranslations.editArbitrationContactMessage = translate[0].editArbitrationContactMessage;
      this.dealerContactTranslations.titleContact = translate[0].titleContact;
      this.dealerContactTranslations.editTitleContact = translate[0].editTitleContact;
      this.dealerContactTranslations.editTitleContactMessage = translate[0].editTitleContactMessage;
      this.dealerContactTranslations.pageHeader = translate[0].pageHeader;
      this.dealerContactTranslations.physicalAddress = translate[0].physicalAddress;
      this.dealerContactTranslations.requestChange = translate[0].requestChange;
      this.dealerContactTranslations.titleAddress = translate[0].titleAddress;
      this.dealerContactTranslations.phoneNumbers = translate[0].phoneNumbers;
      this.dealerContactTranslations.primaryPhone = translate[0].primaryPhone;
      this.dealerContactTranslations.edit = translate[0].edit;
      this.dealerContactTranslations.labelPrimaryPhone = translate[0].labelPrimaryPhone;
      this.dealerContactTranslations.alternatePhone = translate[0].alternatePhone;
      this.dealerContactTranslations.enterPhoneNumber = translate[0].enterPhoneNumber;
      this.dealerContactTranslations.labelContacts = translate[0].labelContacts;
      this.dealerContactTranslations.contactInfo = translate[0].contactInfo;
      this.dealerContactTranslations.editBuyerContact = translate[0].editBuyerContact;
      this.dealerContactTranslations.editBuyerContactInfo = translate[0].editBuyerContactInfo;
      this.dealerContactTranslations.name = translate[0].name;
      this.dealerContactTranslations.enterName = translate[0].enterName;
      this.dealerContactTranslations.email = translate[0].email;
      this.dealerContactTranslations.enterEmail = translate[0].enterEmail;
      this.dealerContactTranslations.phone = translate[0].phone;
      this.dealerContactTranslations.enterPhoneToContinue = translate[0].enterPhoneToContinue;
      this.dealerContactTranslations.sellerContact = translate[0].sellerContact;
      this.dealerContactTranslations.editSellerContact = translate[0].editSellerContact;
      this.dealerContactTranslations.sellerContactInfo = translate[0].sellerContactInfo;
      this.dealerContactTranslations.pickupContact = translate[0].pickupContact;
      this.dealerContactTranslations.editPickupContact = translate[0].editPickupContact;
      this.dealerContactTranslations.editPickupContactMessage = translate[0].editPickupContactMessage;
      this.dealerContactTranslations.ariaLabelRequestPhysical = translate[0].ariaLabelRequestPhysical;
      this.dealerContactTranslations.ariaLabelEditContact = translate[0].ariaLabelEditContact;
      this.dealerContactTranslations.textBuyerContact = translate[0].textBuyerContact;
      this.dealerContactTranslations.captionDealerShip = translate[0].captionDealerShip;
      this.dealerContactTranslations.ariaLabelRequestTitle = translate[0].ariaLabelRequestTitle;
      this.dealerContactTranslations.textAltPhone = translate[0].textAltPhone;
      this.dealerContactTranslations.contactDetailsSuccessfullyUpdate = translate[0].contactDetailsSuccessfullyUpdate;
      this.dealerContactTranslations.alternateBuyerContact = translate[0].alternateBuyerContact;
      this.dealerContactTranslations.alternateSellerContact = translate[0].alternateSellerContact;
      this.dealerContactTranslations.alternatePickupContact = translate[0].alternatePickupContact;
      this.dealerContactTranslations.alternateArbitrationContact = translate[0].alternateArbitrationContact;
      this.dealerContactTranslations.frenchPreferred = translate[0].frenchPreferred;
      this.dealerContactTranslations.labelSameAsSellerCheckbox = translate[0].labelSameAsSellerCheckbox;
      this.dealerContactTranslations.samePrimarySecondaryNameError = translate[0].samePrimarySecondaryNameError;
      this.setMessage();
    });
  }

  showContactsPerRole() {
    this.userHasSingleRole();
    this.userHasMultipleRoles();
  }

  userHasSingleRole() {
    if (this.userRoles.length === 1) {
      if (this.userRoles[0] === 'Enterprise_Buyer') {
        this.showSellerContacts = false;
      }
      if (this.userRoles[0] === 'Dealer_Seller') {
        this.showBuyerContacts = false;
      }
    }
  }

  userHasMultipleRoles() {
    if (this.userRoles.length === 2) {
      if (this.userRoles.includes('Dealer_Seller') && this.userRoles.includes('Lead_Seller')) {
        this.showBuyerContacts = false;
      }
      if (this.userRoles.includes('Beta_Buyer') && this.userRoles.includes('Dealer_Buyer')) {
        this.showSellerContacts = false;
      }
    }
    if (this.userRoles.length === 3) {
      if (this.userRoles.includes('Dealer_Buyer') && this.userRoles.includes('Enhanced_Purchase')) {
        this.showSellerContacts = false;
      }
    }
  }

  sameAsSeller(checkbox, role) {
    if (role === 'buyer') {
      this.updateContactFormHelper(checkbox, role, this.buyerContactForm);
    } else if (role === 'pickup') {
      this.updateContactFormHelper(checkbox, role, this.pickupContactForm);
    } else if (role === 'title') {
      this.updateContactFormHelper(checkbox, role, this.titleContactForm);
    } else if (role === 'arbitration') {
      this.updateContactFormHelper(checkbox, role, this.arbitrationContactForm);
    }
  }

  updateContactFormHelper(checkbox, role, contactForm) {
    if (checkbox.currentTarget.checked) {
      this.sameAsSellerFieldStyle[role] = true;
      contactForm.patchValue({
        name: this.organization.contactDetails.seller.name,
        email: this.organization.contactDetails.seller.email,
        phone: this.reformatPhoneWithoutCountryCode(this.organization.contactDetails.seller.phone)
      });
    } else if (this.organization.contactDetails[role] && !checkbox.currentTarget.checked) {
      this.sameAsSellerFieldStyle[role] = false;
      contactForm.patchValue({
        name: this.organization.contactDetails[role].name,
        email: this.organization.contactDetails[role].email,
        phone: this.reformatPhoneWithoutCountryCode(this.organization.contactDetails[role].phone)
      });
    } else if (this.organization.contactDetails[role] === undefined && !checkbox.currentTarget.checked) {
      this.sameAsSellerFieldStyle[role] = false;
      contactForm.patchValue({ name: '', phone: '', email: '' });
    }
  }
}
